export enum DisplayMode {
  Team = 'team',
  ComparedTeam = 'comparedTeam',
  Player = 'player',
  ComparedPlayer = 'comparedPlayer',
  Match = 'match',
  MatchPlayer = 'matchPlayer',
  MatchComparedPlayer = 'matchComparedPlayer'
}
